import React, { Component, Fragment } from 'react';
import Map from '@ro-components/Map';
import Tutorial from '@ro-components/Tutorial';
// import Preloader from '@ro-atoms/Preloader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { dispatch } from '@ro-store';

import { tutorials } from '@ro-components/Tutorial/utils';

import { tutorialExampleLocation } from '@ro-components/Tutorial/utils';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { MapContainer } from './MapTarget.styles';
import {
  // Fader,
  // MapContainer,
  CustomDialogActions,
  TutorialStepsWrapper
} from './MapTarget.styles';

class MapTarget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      firstLoad: props.firstLoad
    };
  }

  checkLoading() {
    this.setState({
      isLoading: false,
      firstLoad: false
    });
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.currentScan !== nextProps.currentScan) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    return this.state.firstLoad ? this.checkLoading() : null; // jshint ignore:line
  }

  render() {
    const {
      // radarData,
      // lightningsData,
      userSettings,
      helpModal
    } = this.props;

    // const loaded = radarData && lightningsData && !this.state.isLoading;

    return (
      <div>
        {/* <Fader loading={!loaded} data-anim={!loaded ? '' : 'done'}>
          <Preloader alpha="1" overlay="black" position="fixed" />
        </Fader> */}
        <Fragment>
          <MapContainer />
          <Map />
          {
            <Dialog
              open={userSettings.tutorialLevel === 0}
              aria-labelledby="responsive-dialog-title"
              disableBackdropClick={true}
              disableEscapeKeyDown={true}
            >
              <DialogTitle id="responsive-dialog-title">{'Pierwszy raz?'}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Pozwól że opowiemy Ci jak działa aplikacja. Nie zajmiemy Ci dużo czasu, a będzie Ci się łatwiej
                  odnaleźć w nowym programie.
                </DialogContentText>
              </DialogContent>
              <CustomDialogActions>
                <Button variant="contained" onClick={() => dispatch.ro.setTutorialLevel(false)} color="primary">
                  Pomiń
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    this.props.history.push('/');
                    dispatch.ro.setTutorialStartFlag(true);
                    return dispatch.ro.setTutorialLevel(1);
                  }}
                  color="secondary"
                  autoFocus
                >
                  Rozpocznij tutorial i nabierz mocy
                </Button>
              </CustomDialogActions>
            </Dialog>
          }

          {
            <Dialog open={helpModal && userSettings.tutorialLevel}>
              <DialogTitle id="responsive-dialog-title">{'Nie dokończyłeś tutorialu.'}</DialogTitle>
              <DialogContent>
                <DialogContentText>Poniżej znajdują się możliwe rozwiązania.</DialogContentText>
              </DialogContent>
              <CustomDialogActions>
                <Button
                  variant="contained"
                  onClick={() => {
                    dispatch.ro.setTutorialLevel(false);
                    dispatch.ro.setHelpModal(false);
                  }}
                  color="primary"
                >
                  Pomiń
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    dispatch.ro.setTutorialLevel(1);
                    dispatch.ro.setTutorialStartFlag(true);
                    dispatch.ro.setHelpModal(false);
                  }}
                  color="secondary"
                  autoFocus
                >
                  Rozpocznij tutorial od początku
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const tutorial = Object.keys(tutorials)
                      .map((tutorial, index) => userSettings.tutorialLevel - 1 === index && tutorials[tutorial])
                      .filter(item => item)[0];

                    dispatch.ro.setHelpModal(false);
                    this.props.history.push(tutorial.action);
                    if (tutorial.index === 9) {
                      dispatch.ro.setCurrentLocation(tutorialExampleLocation).then(() => {
                        dispatch.ro.setTutorialLevel(tutorial.index);
                        dispatch.ro.setTutorialStartFlag(true);
                      });
                    } else {
                      dispatch.ro.setTutorialLevel(tutorial.index);
                      dispatch.ro.setTutorialStartFlag(true);
                    }
                  }}
                  color="secondary"
                  autoFocus
                >
                  Dokończ tutorial
                </Button>
              </CustomDialogActions>
            </Dialog>
          }

          {
            <Dialog open={helpModal && !userSettings.tutorialLevel}>
              <DialogTitle id="responsive-dialog-title">{'Potrzebujesz pomocy?'}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Możesz wybrać rozdział tutorialu lub przejść go od początku.
                  <br />
                  <br />
                  <TutorialStepsWrapper>
                    {Object.keys(tutorials).map(item => {
                      const tutorial = tutorials[item];
                      return (
                        <Button
                          key={item}
                          variant="contained"
                          size="small"
                          mini={true}
                          onClick={() => {
                            dispatch.ro.setHelpModal(false);
                            this.props.history.push(tutorial.action);
                            if (tutorial.index === 11) {
                              dispatch.ro.setCurrentLocation(tutorialExampleLocation).then(() => {
                                dispatch.ro.setTutorialLevel(tutorial.index);
                                dispatch.ro.setTutorialStartFlag(true);
                              });
                            } else {
                              dispatch.ro.setTutorialLevel(tutorial.index);
                              dispatch.ro.setTutorialStartFlag(true);
                            }
                          }}
                          color="primary"
                        >
                          {tutorial.name}
                        </Button>
                      );
                    })}
                  </TutorialStepsWrapper>
                </DialogContentText>
              </DialogContent>
              <CustomDialogActions>
                <Button
                  variant="contained"
                  onClick={() => {
                    dispatch.ro.setTutorialLevel(false);
                    dispatch.ro.setHelpModal(false);
                  }}
                  color="primary"
                >
                  Pomiń
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    dispatch.ro.setTutorialStartFlag(true);
                    dispatch.ro.setHelpModal(false);
                    dispatch.ro.setTutorialLevel(1);
                  }}
                  color="secondary"
                  autoFocus
                >
                  Rozpocznij tutorial od początku
                </Button>
              </CustomDialogActions>
            </Dialog>
          }

          {
            <Dialog
              open={userSettings.tutorialLevel === 12}
              aria-labelledby="responsive-dialog-title"
              disableBackdropClick={true}
              disableEscapeKeyDown={true}
            >
              <DialogTitle id="responsive-dialog-title">{'Brawo!'}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Skończyłeś tutorial. Gratulujemy, jesteś teraz mistrzem RO, <br />
                  Nie wszystko jednak widziałeś podczas tutorialu. W nowym RO czeka Cię sporo miłych niespodzianek które
                  odkryjesz w trakcie korzystania. Czołem!
                </DialogContentText>
              </DialogContent>
              <CustomDialogActions>
                <Button
                  variant="contained"
                  onClick={() => {
                    this.props.history.push('/');
                    dispatch.ro.setTutorialLevel(1);
                  }}
                  color="primary"
                  autoFocus
                >
                  Przejdź tutorial ponownie
                </Button>
                <Button variant="contained" onClick={() => dispatch.ro.setTutorialLevel(false)} color="secondary">
                  Wyjdź
                </Button>
              </CustomDialogActions>
            </Dialog>
          }
          <Tutorial name="desktop" />
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = ({ ro }) => ro;

export default withRouter(connect(mapStateToProps)(MapTarget));
